import BaseModal from 'flow/components/ui-components/BaseModal';
import useAppContext from 'flow/hooks/useAppContext';
import Checkbox from '../ui-components/Checkbox';
import wrappedLocalStorage from 'flow/utils/local-storage-utils';
import { useState } from 'react';

type Props = {
    onSubmit: () => void;
    onClose: () => void;
};

const CreateSoundModalConfirm = ({ onSubmit, onClose }: Props) => {
    const { i18next } = useAppContext();
    const [checked, setChecked] = useState<boolean>(false);

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked;
        setChecked(isChecked);
        wrappedLocalStorage.setItem(
            'tts-generated',
            isChecked ? 'true' : 'false',
        );
    };

    return (
        <BaseModal
            open={true}
            ariaLabel={i18next.t('Recorder.tts.confirm')}
            onSubmit={onSubmit}
            confirmButtonText={i18next.t('app.confirm')}
            preventCloseOnSubmit={true}
            hideCancelButton={true}
            closeIconAction={onClose}
        >
            <p className="mb-4">{i18next.t('Recorder.tts.confirm')}</p>
            <Checkbox
                label={i18next.t('Recorder.tts.confirm.checkbox')}
                checked={checked}
                onChange={onChange}
            />
        </BaseModal>
    );
};

export default CreateSoundModalConfirm;
